import type { AnyFile } from "../types/any-file";

export const getFileFeatureType = (fileOrDirectory: AnyFile) =>
  fileOrDirectory.descriptor?.meta?.featureTypeDefinition ||
  fileOrDirectory.meta?.featureTypeDefinition ||
  undefined;
